export enum EmbedRoute {
  TRENDING_LANDS = '/embed/trending-lands',
  LAND_MARKET_DATA_TICKER = '/embed/market-data-ticker/:tokenSymbol',
  LAND_MARKET_PRICE_TICKER = '/embed/market-price-ticker/:tokenSymbol',
}
